import { defineMessages } from 'react-intl';

export const SingleValueGridMessages = defineMessages({
  gridIntentsLabel: {
    id: 'HnUFKqpr47NWwlve',
    defaultMessage: 'Grid options',
    description: 'Label for the grid intents in the SingleValueGrid toolbar',
  },
});
